import { render } from "./RuleSelectorYear.vue?vue&type=template&id=1a467b5b&scoped=true"
import script from "./RuleSelectorYear.vue?vue&type=script&lang=js"
export * from "./RuleSelectorYear.vue?vue&type=script&lang=js"

import "./RuleSelectorYear.vue?vue&type=style&index=0&id=1a467b5b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a467b5b"]])

export default __exports__